import { Directive, AfterContentInit, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[dtAutoFocus]',
  standalone: false
})
export class AutofocusDirective implements AfterContentInit {

  @Input() public dtAutoFocus;

  public constructor(private el: ElementRef) {}

  setCaretPosition(ctrl, pos) {
    // Modern browsers
    if (ctrl.setSelectionRange) {
      ctrl.focus();
      ctrl.setSelectionRange(pos, pos);
    // IE8 and below
    } else if (ctrl.createTextRange) {
      const range = ctrl.createTextRange();
      range.collapse(true);
      range.moveEnd('character', pos);
      range.moveStart('character', pos);
      range.select();
    }
  }

  public ngAfterContentInit() {
      setTimeout(() => {
        try {
          this.el.nativeElement.focus();
          this.setCaretPosition(this.el.nativeElement,
             this.dtAutoFocus !== '' ? this.dtAutoFocus : this.el.nativeElement.value.length);
        } catch (e) {
          console.error(e);
        }
      }, 500);
  }
}
